<div class="reports-area">
  <h2>Reports</h2>

  <form clrForm clrLayout="vertical" autocomplete="off" class="select-report">

    <clr-select-container>
      <label class="clr-col-12">Select report</label>
      <select clrSelect class="clr-col-12" name="reports" [(ngModel)]="selectedReport">
        <option *ngFor="let report of reports" [ngValue]="report">{{report.name}}</option>
      </select>
    </clr-select-container>
    <p class="select-report"><i>{{selectedReport?.description ?? ''}}</i></p>
  </form>

  <button type="button" class="btn btn-outline execute-button" [clrLoading]="executeState"
  (click)="executeReport()">
  Execute report
</button>
</div>
